import '../styles/NavBar.css';
import 'font-awesome/css/font-awesome.min.css';

import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const NavBar = () => {
    return (
        <nav className="navbar">
            <div className="company-name">JIAQIWANG AQUASTUDIO ●</div>
            <div className="nav-links">
                <Link to="/aboutme" className="nav-link">About Me</Link> {/* Change to Link */}
                <Link to="/projects" className="nav-link">Projects</Link> {/* Example of another route */}
                <a href="https://pelicanflowspace.vercel.app/" className="nav-link" target="_blank" rel="noopener noreferrer">
                    Blogs
                </a>            
            </div>
            <Link to="/" className="home-link nav-link">Home</Link> {/* Change to Link */}
        </nav>
    );
};

export default NavBar;